import Vue from 'vue'
import api from '../../api'
import Constants from '../../constants'
import i18n from '../../i18n'
import _ from 'lodash'

const getDefaultState = () => {
  return {
    token: null,
    recoveryCode: null,
    lang: null,
    filter: {},
    profile: null,
    changeProfile: null,
    appId: null
  }
}

const state = getDefaultState()

const getters = {
  getToken: (state) => state.token || Vue.$cookies.get(Constants.TOKEN_KEY),
  getRecoveryCode: (state) => state.recoveryCode || Vue.$cookies.get(Constants.RECOVERY_CODE_KEY),
  getLang: (state) => state.lang,
  getAppId: (state) => state.appId,
  isFilterOn: (state) => (genre) => {
    return !!state.filter[genre.id]
  },
  getFilter: (state) => state.filter,
  getProfile: (state) => state.profile,
  getChangeProfile: (state) => state.changeProfile
}

const actions = {
  setToken ({ commit, dispatch }, params) {
    dispatch('resetAll', {}, { root: true })
    Vue.$cookies.set(Constants.TOKEN_KEY, params)

    commit('setToken', { token: params })
  },
  setTokenAndRecoveryCode({ commit }, params) {
    Vue.$cookies.set(Constants.TOKEN_KEY, params.token)
    Vue.$cookies.set(Constants.RECOVERY_CODE_KEY, params.recoveryCode)

    commit('setTokenAndRecoveryCode', params)
  },
  setProfile ({ commit }, params) {
    commit('setProfile', params.profile)
  },
  changeProfile ({ commit }, params) {
    commit('changeProfile', params.profile)
  },
  clearChangeProfile ({ commit }) {
    commit('clearChangeProfile')
  },
  setStayPlace({ commit }, params) {
    commit('setStayPlace', params.place)
  },
  clearStayPlace({ commit }) {
    commit('clearStayPlace')
  },
  updateProfile ({ commit }, params) {
    return new Promise((resolve) => {
      api.putUserProfile(params)
        .then(() => {
          commit('setProfile', params.profile)
          resolve()
        })
    })
  },
  setLang ({ commit }, params) {
    if (Constants.AVAILABLE_LANGUAGES.includes(params)) {
      i18n.locale = params
    } else {
      i18n.locale = 'ja'
    }
    commit('setLang', { lang: i18n.locale })
  },
  onFilterFromTag ({ commit }, tagId) {
    const genre = {
      id: tagId
    }
    commit('setOnFilter', genre)
  },
  offFilterFromTag ({ commit }, tagId) {
    const genre = {
      id: tagId
    }
    commit('setOffFilter', genre)
  },
  onFilter ({ commit }, genre) {
    commit('setOnFilter', genre)
  },
  offFilter ({ commit }, genre) {
    commit('setOffFilter', genre)
  },
  updateFilter ({ commit, state }, genres) {
    var filter = {};
    if (state.filter !== undefined && !_.isEmpty(state.filter)) {
      filter = Object.assign({}, state.filter);
    }
    genres.forEach((genre) => {
      if (genre.filter && filter[genre.id] === undefined) {
        filter[genre.id] = genre.filterDefault
      }
    })
    commit('setFilter', filter)
  },
  reset ({ commit }) {
    commit('resetState')
    Vue.$cookies.remove(Constants.TOKEN_KEY)
  }
}

const mutations = {
  setToken (state, { token }) {
    state.token = token
    state.appId = Constants.API_ID
  },
  setTokenAndRecoveryCode(state, { token, recoveryCode }) {
    state.token = token
    state.recoveryCode = recoveryCode
    state.appId = Constants.API_ID
  },
  setProfile (state, profile) {
    if (profile !== undefined) {
      state.profile = profile
    }
  },
  changeProfile (state, profile) {
    state.changeProfile = profile;
  },
  setStayPlace (state, stayPlace) {
    state.changeProfile.otherPlace = stayPlace
  },
  clearStayPlace (state) {
    state.changeProfile.otherPlace = null
  },
  clearChangeProfile (state) {
    state.changeProfile = null
  },
  setLang (state, { lang }) {
    state.lang = lang
  },
  setFilter (state, genres) {
    state.filter = genres
  },
  setOnFilter (state, genre) {
    state.filter[genre.id] = true
  },
  setOffFilter (state, genre) {
    state.filter[genre.id] = false
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
